import {
    SourceDrawRect,
    ApTimelineBasic,
    MarkerStyle,
    MarkerApi,
    Marker,
} from '@accurate-player/accurate-player-components-external';
import {CreatedOrUpdatedByUser} from '@pluto/rest';
import {MutableRefObject} from 'react';

export interface BaseMarker {
    identifier: string;
    markerStyle?: MarkerStyle;
    text?: string;
    createdByUser?: CreatedOrUpdatedByUser;
    updatedAt?: string;
}

export interface TimelineMarker extends BaseMarker {
    start: number;
    end: number;
}

export interface MarkupMarker extends TimelineMarker {
    issue: number;
}

export interface QCReportMarker extends BaseMarker {
    start?: number;
    end?: number;
    issue?: number;
    details: string;
}

export type PartialTimelineMarker = Partial<TimelineMarker>;

export type PartialMarkupMarker = Partial<MarkupMarker>;

export type TooltipMarker = {
    text: string;
    headerText: string;
    left: number;
    top: number;
    width: number;
    maxRight: number;
}

export type TimeLineRef = MutableRefObject<ApTimelineBasic | null>;

export type MouseTouchEvent = MouseEvent | TouchEvent;

export type OnTimelineMarkerClick = (marker: TimelineMarker, api: MarkerApi, event: MouseTouchEvent) => void;

export type OnTimelineMarkerEnter = (marker: Marker, api: MarkerApi, event: MouseTouchEvent) => void;

export type OnTimelineMarkerLeave = () => void;

export type TooltipMarkerOrUndefined = TooltipMarker | undefined;

export type MarkerOrUndefined = TimelineMarker | undefined;

export interface ThumbnailMarker {
    identifier: string;
    start: number;
    src: string;
    srcDrawRect?: SourceDrawRect;
}

export enum TimelineRowType {
    AdBreak = 'AdBreak',
    QCReport = 'QCReport',
    Markup = 'Markup',
    BlackFrame = 'BlackFrame',
    Subtitle = 'Subtitle',
    Unknown = 'Unknown',
}

export interface TimelineRow {
    identifier: string;
    label: string;
    type: TimelineRowType;
    markers: TimelineMarker[];
}

export type ButtonClickEvent = React.MouseEvent<HTMLButtonElement, MouseEvent>;
